/**
 * Negative is not a match and positive is a match, so this rank zero strikes a middle ground
 * that will render but only if other positive matches aren't found.
 */
export const RENDERER_RANK_LAST_RESORT = 0;
/**
 * Lowest positive so that it matches but allows more specific types to override.
 */
export const RENDERER_RANK_DEFAULT_FALLBACK = 1;
/**
 * Positive higher than lowest so that it can override any default and be chosen above fallbacks.
 */
export const RENDERER_RANK_PREFERRED_MATCH = 2;
